import { pixelSize } from "../../../styles";

/**
 * The number of tiles per row and column.
 * IMPORTANT! Check styles before changing this value!
 *
 * @constant {number}
 */
export const tileCount = 4;

/**
 * The duration of every animation in ms.
 * IMPORTANT! Check styles before modyfing this value!
 *
 * @constant {number} ms
 */
export const animationDuration = 250;

/**
 * The board margin (left, right, top, bottom).
 */
export const boardMargin = 2 * pixelSize;
